export const DEFAULT_URLS = {
  TERMS_OF_USE: 'https://kyc.datascouts.eu/terms',
  PRIVACY_POLICY: 'https://datascouts.eu/wp-content/uploads/2024/03/privacy_en.pdf',
  COOKIE_POLICY: 'https://datascouts.eu/cookie-policy/',
  FAQ: 'https://www.datascouts.eu/faq',
}
